module.exports = __webpack_public_path__ + "images/pro/pro-black-e7d7f5c15c0b0b9ee6564a6e5f5d9234.png";